import Control from "sap/ui/core/Control";
import RenderManager from "sap/ui/core/RenderManager";
import { MetadataOptions } from "sap/ui/core/Element";
import Icon from "sap/ui/core/Icon";
import { ImportRequestLogStatus } from "vamos/cockpit/model/odata/VamosModel";

/**
 * @namespace vamos.cockpit.data.import.history.control
 */
export default class ImportHistoryStatusIcon extends Control {

  static readonly metadata: MetadataOptions = {
    properties: {
      importHistoryStatus: {
        type: "any",
        defaultValue: "",
      },
    },
    aggregations: {
      _icon: {
        type: "sap.ui.core.Icon",
        multiple: false,
        visibility: "hidden",
      },
    },
  };

  private _resolveStatusOfImportHistory(importRequestLogStatus: ImportRequestLogStatus): void {
    let path = "";
    let color = "";
    if (importRequestLogStatus === ImportRequestLogStatus.NEW) {
      path = "sap-icon://complete";
      color = "green";
    } else if (importRequestLogStatus === ImportRequestLogStatus.OVERWRITTEN) {
      path = "sap-icon://circle-task-2";
      color = "#ffcc00";
    } else if (importRequestLogStatus === ImportRequestLogStatus.ERROR) {
      path = "sap-icon://decline";
      color = "red";
    }
    const icon: Icon = this.getAggregation("_icon") as Icon;
    icon.setSrc(path);
    icon.setColor(color);
  }


  public setImportHistoryStatus(importHistoryStatus: any) {
    this.setProperty("importHistoryStatus", importHistoryStatus, true);
    this._resolveStatusOfImportHistory(importHistoryStatus as ImportRequestLogStatus);
  }

  init(): void {
    this.setAggregation("_icon", new Icon());
  }

  renderer = {
    apiVersion: 4,
    render: (rm: RenderManager, control: ImportHistoryStatusIcon) => {
      rm.renderControl(control.getAggregation("_icon") as Control);
    },
  };
};